<template>
  <div class="box">
    
    <h1>累计销售金额:{{ sumRechargeAmount }} &nbsp;&nbsp;&nbsp;&nbsp;累计分成金额:{{ sumDevideAmount }}</h1>
    <Tabs value="1">
      <TabPane label="按日统计（最近30天）" name="1">
        <Table stripe :columns="columns1" :data="dayData"></Table
      ></TabPane>
      <TabPane label="按月统计（最近12个月）" name="2">
        <Table stripe :columns="columns2" :data="monthData"></Table>
      </TabPane>
    </Tabs>
    <Modal v-model="modal" title="日期统计">
      <Table stripe :columns="columns1" :data="modalDay"></Table>
    </Modal>
  </div>
</template>
<script>
import { getSummaryReport } from "@/api/api"; //接口测试
export default {
  data() {
    return {
      modal: false,
      sumDevideAmount: 0,
      sumRechargeAmount:0,
      startTime: "",
      monthVlaue: "",
      endTime: "",
      dayData: [],
      monthData: [],
      modalDay: [], //弹窗数据
      columns1: [
        {
          title: "日期",
          key: "reportDate",
        },
         {
          title: "销售金额",
          key: "rechargeAmount",
        },
         {
          title: "分成比例",
          key: "devideRatio",
          render:(h,params)=>{
            return h('span',{

            },params.row.devideRatio+'%')
          }
        },
        {
          title: "分成金额",
          key: "shareAmount",
        },
      ],
      columns2: [
        {
          title: "月份",
          key: "reportDate",
        },
            {
          title: "销售金额",
          key: "rechargeAmount",
        },
        {
          title: "分成金额",
          key: "shareAmount",
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#409eff",
                    marginRight: "5px",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.checkView(params.row);
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      type: 0,
    };
  },
  mounted() {
    this.getData(1);
    this.getData(2);
  },
  methods: {
    getData(type) {
      var params = {
        type: type,
        endTime: "",
        startTime: "",
      };
      getSummaryReport(params).then((res) => {
        if (res.code == 200) {
          if (type == 1) {
            this.dayData = res.data;
          } else {
            this.monthData = res.data;
          }
          this.sumDevideAmount = res.sumDevideAmount;
          this.sumRechargeAmount= res.sumRechargeAmount
        }
      });
    },
    checkView(row) {
      var year = row.reportDate.split("-")[0];
      var month = row.reportDate.split("-")[1];
      var d = new Date(year, month, 0);
      var startTime = row.reportDate + "-01";
      var endTime = row.reportDate + "-" + d.getDate();
      this.getDatas(1, endTime, startTime);
    },
    getDatas(type, endTime, startTime) {
      var params = {
        type: type,
        endTime: endTime,
        startTime: startTime,
      };
      getSummaryReport(params).then((res) => {
        if (res.code == 200 && res.data != null) {
          this.modal = true;
          this.modalDay = res.data;
        } else {
          this.modalDay = [];
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 50px;
  > h1 {
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/summary/summary.vue